import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useGetDashboard from 'routes/Explore/hooks/useGetDashboard';

export const useInternalLinkAccess = (pathname: string, disabled: boolean) => {
    const { t } = useTranslation();
    const [isDisabled, setIsDisabled] = useState(disabled);
    const [tooltipMessage, setTooltipMessage] = useState('');

    const splittedUrl = pathname.split('/');
    const isTargetDashboardPage = splittedUrl[1] === 'dashboard';
    const targetSlug = isTargetDashboardPage ? splittedUrl[2] : null;

    const {
        data: dashboard,
        error,
        isLoading,
    } = useGetDashboard(targetSlug, undefined, false);

    useEffect(() => {
        if (!isTargetDashboardPage) {
            setIsDisabled(disabled);
            setTooltipMessage('');
            return;
        }

        if (isLoading) return;

        if (error) {
            const { status, message } = error;

            if (status === 400 && message === 'error.slug_unknown') {
                setIsDisabled(true);
                setTooltipMessage(t('widget.navlink.dashboardNotFound'));
            } else if (
                status === 403 &&
                message === 'error.no_dashboard_access'
            ) {
                setIsDisabled(true);
                setTooltipMessage(t('widget.navlink.noAccessToDashboard'));
            } else {
                setIsDisabled(true);
                setTooltipMessage(t('widget.navlink.genericDashboardError'));
            }
        } else {
            setIsDisabled(false);
            setTooltipMessage('');
        }
    }, [
        isTargetDashboardPage,
        targetSlug,
        disabled,
        isLoading,
        error,
        dashboard,
    ]);

    return { isDisabled, tooltipMessage };
};
